module.exports = __webpack_public_path__ + "static/media/pause.ae739fe7.svg";